import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'

export const communityGardenDocumentStatus = enumerated({
  pending: 'Pendente',
  approved: 'Aprovado',
  rejected: 'Rejeitado',
})

export const communityGardenDocumentObject = z.object({
  id: z.string().uuid(),
  communityGardenId: z.string().uuid(),
  privateFileId: z.string().uuid().nullish(),
  gcsIdentifier: z.string().nullish(),
  url: z.string().nullish(),
  fileName: z.string().nullish(),
  mimeType: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  status: communityGardenDocumentStatus,
})

export type CommunityGardenDocumentType = z.infer<typeof communityGardenDocumentObject>

export default communityGardenDocumentObject

export const propertyMap = {
  id: sql`community_garden_document.id`,
  communityGardenId: sql`community_garden_document.community_garden_id`,
  privateFileId: sql`community_garden_document.private_file_id`,
  gcsIdentifier: sql`community_garden_document.gcs_identifier`,
  url: sql`community_garden_document.url`,
  fileName: sql`community_garden_document.file_name`,
  mimeType: sql`community_garden_document.mime_type`,
  createdAt: sql`community_garden_document.created_at`,
  updatedAt: sql`community_garden_document.updated_at`,
  deletedAt: sql`community_garden_document.deleted_at`,
  status: sql`community_garden_document.status`,
}
